import { render } from "./TestComponent.vue?vue&type=template&id=2b0e707a&ts=true"
import script from "./TestComponent.vue?vue&type=script&lang=ts"
export * from "./TestComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__